module.exports = __webpack_public_path__ + "img/cointelegraph.733783bf.png";